import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./Main_labels.css";
import Response_Processing from '../../../../layout/Others/Response_Processing';

function MainLabels() {
    const [tab, setTab] = useState(""); // Current active tab (display_for value)
    const [labelOptions, setLabelOptions] = useState([]); // Options for tabs
    const [labelDisplay, setLabelDisplay] = useState([]); // Data to display in the current tab

    const access_token = localStorage.getItem("access_token");
    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access_token}`,
        Accept: "application/json",
    };

    // Fetch "create" API data to determine available tabs
    useEffect(() => {
        const fetchLabelOptions = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_Baseurl}/admin/Label-Management/create`,
                    { headers: headers }
                );
                const options = response?.data?.data || [];
                setLabelOptions(options);

                if (options.length > 0) {
                    setTab(options[0].value);
                }
            } catch (error) {
                console.error("Error fetching label options:", error);
            }
        };

        fetchLabelOptions();
    }, []);

    // Fetch "list-display" API data whenever the active tab changes
    const [loading, setLoading] = useState(false); // Loading state

    useEffect(() => {
        const fetchLabelDisplay = async () => {
            setLoading(true); // Start loading
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_Baseurl}/admin/Label-Management/list-display`,
                    {
                        headers: headers,
                        params: { display_for: tab },
                    }
                );
                setLabelDisplay(response?.data?.label_management || []);
            } catch (error) {
                console.error("Error fetching label display:", error);
            } finally {
                setLoading(false); 
            }
        };

        if (tab) {
            fetchLabelDisplay();
        }
    }, [tab]);

    return (
        <div className="iq-card">
            {/* Tabs */}
            <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                {labelOptions?.map((option) => (
                    <li
                        key={option?.value}
                        className="nav-item col-lg-4 col-sm-4 col-4"
                        role="presentation"
                    >
                        <button
                            className={`nav-link ${tab === option.value ? "active" : ""} w-100`}
                            onClick={() => setTab(option?.value)}
                            type="button"
                            role="tab"
                        >
                            {option?.name} LABELS
                        </button>
                    </li>
                ))}
            </ul>

            {/* Tab Content */}
            <div className="tab-content" id="pills-tabContent">
                <div
                    className={`tab-pane fade show ${tab ? "active" : ""}`}
                    id="pills-home"
                    role="tabpanel"
                >
                    <div className="m-0 p-0">
                        <section className="section container-fluid dashboard p-2">
                            <div className="row">
                                {loading ? (
                                    <p><Response_Processing /></p>
                                ) : labelDisplay?.length > 0 ? ( // Check if labelDisplay has items
                                    labelDisplay?.map((item) => {
                                        // Declare formattedString within the map function scope
                                        const formattedString = item?.source
                                            .split('-')
                                            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                                            .join(' ');

                                        return (
                                            <div key={item.source} className="col-lg-4 col-md-6 col-sm-12 p-2">
                                                <Link className="site-setting" to={`/label/${item?.source}`}>
                                                    <div className="sitecard p-2">
                                                        <div className="row">
                                                            <div className="col-12">
                                                                <div className="card-body p-2">
                                                                    <h5 className="card-title">{formattedString}</h5>
                                                                    <p>{item?.source_description || "No description available"}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </div>
                                        );
                                    })
                                ) : (
                                    <>
                                        <div className="text-center">
                                            <p>No data available</p>
                                        </div>
                                    </>
                                )}
                            </div>

                        </section>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MainLabels;
